import {
  arrayOf, params, string, shape, bool, extend
} from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';

export const dataModel = extend({
  product: params({ itemId: string().isRequired(), dataSource: string() }).shape({
    itemId: string(),
    dataSources: string(),
    taxonomy: shape({
      breadCrumbs: arrayOf(shape({
        label: string()
      }))
    })
  }),
  fbr: params({ itemId: string().isRequired(), storeId: string() }).shape({
    recommendedProductSet: string(),
    fbrItems: arrayOf(shape({
      recommendedFeatures: arrayOf(shape({
        name: string(),
        value: string()
      })),
      product: shape(extend({
        itemId: string(),
        dataSources: string(),
        identifiers: shape({
          brandName: string(),
          canonicalUrl: string(),
          itemId: string(),
          productLabel: string()
        }),
        media: shape({
          images: arrayOf(shape({
            url: string(),
            type: string(),
            subType: string(),
            sizes: arrayOf(string()),
          }))
        }),
        // mapAboveOriginalPrice = false,  = false, mapScenario = false
        pricing: params({ storeId: string() }).shape({
          mapAboveOriginalPrice: bool()
        }),
        reviews: shape({
          ratingsReviews: shape({
            averageRating: string(),
            totalReviews: string(),
          })
        }),
      }, Price.dataModel.product))
    }))
  })
});
